import { namespace } from 'vuex-class';
import { ISettingsState } from '@/settings/store/settings.types';

export const Settings = namespace('settings');

export const state: ISettingsState = {
  loading: false,
};
export enum ESettingsActions {
  Load = 'load',
}

export enum ESettingsMutations {
  SetLoading = 'setLoading',
}
